import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IFormDelegate, IFormOptions } from '@modeso/aumico-lib-core-fe';
import {
    IAccountMappingSubFLI,
    IAccountMappingTemplateGroupItemFLI,
    ItemType,
} from '@modeso/types__aumico-lib-annualreport-be';
import { INameId } from '@modeso/types__aumico-lib-core-be';
import { UntilDestroy } from '@ngneat/until-destroy';
import { I18NextService } from 'angular-i18next';
import { v4 } from 'uuid';
import { SubFLIFormHelper } from '../../../helpers/subFliFormHelper';
export interface SubFliDialogData {
    allFlis: IAccountMappingTemplateGroupItemFLI[];
    language: string;
    showOfThatItemCheckBox: boolean;
}

@UntilDestroy()
@Component({
    // tslint:disable-next-line: component-selector
    selector: 'templates-sub-fli-form',
    templateUrl: 'sub-fli-form.dialog.html',
    styleUrls: ['sub-fli-form.dialog.scss'],
})
export class SubFliFormDialog implements OnInit {
    // tslint:disable-next-line: variable-name
    allFlis: IAccountMappingTemplateGroupItemFLI[];
    showOfThatItemCheckBox: boolean;
    private language = 'de-ch';

    private isOfThatItem = false;

    @Output()
    saveEvent = new EventEmitter<{
        subFli: IAccountMappingSubFLI;
        parent: IAccountMappingTemplateGroupItemFLI;
    }>();

    formDelegate: IFormDelegate;
    newState: {
        name: string;
        caption: string;
        parent: { id: string; name: string; item: IAccountMappingTemplateGroupItemFLI };
    } = {} as any;

    options: IFormOptions;

    constructor(
        private localizedTexts: I18NextService,
        @Inject(MAT_DIALOG_DATA) public data: SubFliDialogData,
        private matDialog: MatDialogRef<SubFliFormDialog>,
    ) {
        this.applyLocalizations();
        this.allFlis = data.allFlis;
        this.language = data.language;
        this.showOfThatItemCheckBox = data.showOfThatItemCheckBox;
    }

    ngOnInit(): void {
        this.prepareFields();
        const that = this;
        this.formDelegate = {
            onSubmit(result, formOptions) {
                that.savePressed(result);
            },
        };
    }

    public onOfThatItemCheckBoxValueChanged(isOfThatItem: MatCheckboxChange): void {
        this.isOfThatItem = isOfThatItem.checked;
    }

    private applyLocalizations(): void {
        if (this.allFlis != null && this.allFlis.length > 0) {
            this.prepareFields();
        }
    }

    private prepareFields(): void {
        const fliOptions = this.allFlis.map((fli) => {
            return {
                id: v4(),
                name: fli.caption,
                item: fli,
            };
        }) as INameId[];
        this.options = {
            properties: [
                {
                    name: this.localizedTexts.t('aumico_templates_caption') as string,
                    type: 'text',
                    property: 'caption',
                    required: true,
                },
                {
                    name: this.localizedTexts.t('aumico_templates_sub_fli_form_fli') as string,
                    type: 'select',
                    multiple: false,
                    options: fliOptions,
                    optionsLabel: this.localizedTexts.t('aumico_templates_sub_fli_form_fli_options_label') as string,
                    property: 'parent',
                    required: true,
                },
            ],
            submitText: this.localizedTexts.t('aumico_templates_save') as string,
        };
    }

    savePressed(result: SubFliFormDialog['newState']): void {
        const min = 100000;
        const max = 900000;

        const currentSubFli = {
            name: SubFLIFormHelper.generateSubFliName(result.caption, min, max, this.language),
            caption: result.caption,
            type: this.isOfThatItem ? ItemType.OF_THAT_ITEM : ItemType.SUB_FLI,
            accounts: [],
        } as IAccountMappingSubFLI;

        const fliSelected = result.parent.item;
        this.saveEvent.emit({
            subFli: currentSubFli,
            parent: fliSelected,
        });
    }

    onClose(): void {
        this.matDialog.close();
    }
}
